/**
 * Named choices kept in this browser under `key`, each as the text its page
 * already knows how to read back (a points table, a `?…` of bans).
 */
export function shelf(key: string) {
  /** Every saved entry, by name. Empty when storage is unavailable. */
  const list = (): Record<string, string> => {
    try {
      const stored: unknown = JSON.parse(localStorage.getItem(key) ?? '{}')
      return stored && typeof stored === 'object' ? (stored as Record<string, string>) : {}
    } catch {
      return {}
    }
  }
  const store = (saved: Record<string, string>): boolean => {
    try {
      localStorage.setItem(key, JSON.stringify(saved))
      return true
    } catch {
      return false
    }
  }
  return {
    list,
    /** Saves under `name`, replacing an entry of the same name. False when storage refused. */
    save: (name: string, text: string) => store({ ...list(), [name]: text }),
    remove: (name: string) => {
      const { [name]: _gone, ...rest } = list()
      return store(rest)
    },
  }
}
